import { RedactionAnnotation } from './redaction-annotation.model';
import { LifeCycleEdit } from './life-cycle-edit.enum';

export class RedactionAnnotationEdit extends RedactionAnnotation {
  clientId: number;
  status: LifeCycleEdit;

  constructor(edit: RedactionAnnotation, clientId: number) {
    super();
    this.clientId = clientId;
    this.id = edit.id;
    this.docId = edit.docId
    this.userId = edit.userId;
    this.fileId = edit.fileId;
    this.rank = edit.rank;
    this.x = edit.x;
    this.y = edit.y;
    this.width = edit.width;
    this.height = edit.height;
    this.text = edit.text;
    this.highlightColor = edit.highlightColor;
    this.highlightColorId = edit.highlightColorId;
    this.status = LifeCycleEdit.Unknown;
    this.autoRedactionRuleId = edit.autoRedactionRuleId;
    this.autoRedactionRule = edit.autoRedactionRule;
  }

  toBase(): RedactionAnnotation {
    const edit: RedactionAnnotation = new RedactionAnnotation;
    if (this.id) edit.id = this.id;
    edit.docId = this.docId;
    edit.userId = this.userId;
    edit.fileId = this.fileId;
    edit.rank = this.rank;
    edit.x = this.x;
    edit.y = this.y;
    edit.width = this.width;
    edit.height = this.height;
    edit.text = this.text;
    edit.autoRedactionRuleId = this.autoRedactionRuleId;
    edit.autoRedactionRule = this.autoRedactionRule;
    if (this.highlightColor) edit.highlightColor = this.highlightColor;
    if(this.highlightColorId) edit.highlightColorId = this.highlightColorId;
    return edit;
  }
}
